import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
  Container,
  Tabs,
  Tab,
  Box as MuiBox,
} from "@mui/material";
import { TabContext, TabPanel } from "@mui/lab";
import ImagePreviewModal from "./component/ImagePreviewModal";
import { useLocation } from "react-router-dom";

const AdmissionDetails = () => {
  // const student = {
  //   applied_course: "course name",
  //   father_name: "fathers name",
  //   mother_name: "Rashmi Das",
  //   town_village: "guwahati",
  //   bylane: "bylane",
  //   house_number: "2",
  //   district: "kamrup",
  //   post_office: "post office",
  //   police_station: "police station",
  //   pin_code: "781005",
  //   state: "assam",
  //   id: 11511,
  //   name: "Mriganka Hazarika",
  //   email: "hmrigank@gmail.com",
  //   phone: "",
  //   idproof: "",
  //   idproofimage: "",
  //   adproof: "",
  //   adproofimage: "",
  //   admitimage: "",
  //   tenmarksimage: "",
  //   twelvemarksimage: "",
  //   remarks: null,
  //   created_at: "2025-03-18 07:02:02",
  //   updated_at: "2025-03-18 07:02:02",
  //   dob: "2025-03-18",
  //   age: 99,
  //   gender: "male",
  //   nationality: "nationality",
  //   religion: "Religion",
  //   community: "community",
  //   category: "OBC",
  //   contact_number: "8474003779",
  //   whatsapp_number: "9090909090",
  //   parents_number: "0101010101",
  //   qualification: "Your Past Qualification",
  //   pcb_percentage: "11",
  //   school_college_name: "Mriganka Hazarika",
  //   academic_year: "accedemic year",
  //   comm_village_town: "Kamrup Metropolitan",
  //   comm_path_bylane: "1st house",
  //   comm_house_number: "03",
  //   comm_post_office: "post office",
  //   comm_police_station: "police station",
  //   comm_district: "district",
  //   comm_state: "Assam",
  //   comm_pin_code: "781005",
  //   comm_phone_no_1: "0909090909",
  //   comm_phone_no_2: "243243423",
  //   declaration_date: "2025-03-19",
  //   declaration_place: "guwahati",
  //   declaration_candidate_signature:
  //     "candidate_signature_Mriganka_Hazarika_1742281322.jpeg",
  //   declaration_course_name: "course name",
  //   declaration_relationship: "father",
  //   declaration_occupation: "occupation",
  //   declaration_parents_signature:
  //     "parent_signature_Mriganka_Hazarika_1742281322.jpeg",
  //   heard_about_us: "on social media sites",
  //   hslc_admit_card_image: "hslc_admit_card_Mriganka_Hazarika_1742281322.jpeg",
  //   hslc_marksheet_image: "hslc_marksheet_Mriganka_Hazarika_1742281322.webp",
  //   hslc_pass_certificate_image:
  //     "hslc_pass_certificate_Mriganka_Hazarika_1742281322.jpeg",
  //   hs_admit_card_image: "hs_admit_card_Mriganka_Hazarika_1742281322.jpeg",
  //   hs_marksheet_image: "hs_marksheet_Mriganka_Hazarika_1742281322.jpeg",
  //   hs_certificate_image: "hs_certificate_Mriganka_Hazarika_1742281322.jpeg",
  //   hs_migration_image: "hs_migration_Mriganka_Hazarika_1742281322.jpg",
  //   gnm_marksheet_image: "gnm_marksheet_Mriganka_Hazarika_1742281322.png",
  //   gnm_certificate_image: null,
  //   gnm_migration_image: null,
  //   other_prc_image: null,
  //   other_caste_image: null,
  //   other_registration_image: null,
  //   other_experience_image: null,
  //   other_certificate_image: null,
  //   candidate_signature_image: null,
  //   parent_signature_image: null,
  //   academic_reports:
  //     '{"reports":[{"nameOfExam":"matric","boardOrUniversity":"seba","instituteSchool":"akhs institution","marksObtained":"589","yearOfPassing":"2014","result":"a","percentageMarks":"97%"},{"nameOfExam":"hslc","boardOrUniversity":"ahsec","instituteSchool":"north guwahati","marksObtained":"466","yearOfPassing":"2016","result":"a","percentageMarks":"77"},{"nameOfExam":"mathematics degree","boardOrUniversity":"AHSEC","instituteSchool":"gauhati university","marksObtained":"566","yearOfPassing":"2019","result":"a","percentageMarks":"77"}]}',
  //   hslc_documents: '["hslc_admit","hslc_marksheet"]',
  //   hs_documents:
  //     '["hs_admit_card","hs_marksheet","hs_certificate","hs_migration"]',
  //   gnm_documents: '["gnm_marksheet","gnm_pass_certificate","gnm_migration"]',
  //   other_documents:
  //     '["other_registration","other_certificate","other_experience","other_prc","other_caste"]',
  //   id_proof_documents: '["id_proof_voter","id_proof_adhaar","id_proof_pan"]',
  //   id_proof_adhaar_image: "id_proof_adhaar_Mriganka_Hazarika_1742281322.png",
  //   id_proof_pan_image: "id_proof_pan_Mriganka_Hazarika_1742281322.jpg",
  //   id_proof_voter_image: "id_proof_voter_Mriganka_Hazarika_1742281322.jpg",
  // };
  const location = useLocation();
  const { data } = location.state;
  const student = data;
  console.log(location, "check student info props");

  const academicReports = JSON.parse(
    student.academic_reports || '{"reports":[]}'
  );
  const hslcDocuments = JSON.parse(student.hslc_documents || "[]");
  const hsDocuments = JSON.parse(student.hs_documents || "[]");
  const gnmDocuments = JSON.parse(student.gnm_documents || "[]");
  const otherDocuments = JSON.parse(student.other_documents || "[]");
  const idProofDocuments = JSON.parse(student.id_proof_documents || "[]");

  const [tabValue, setTabValue] = useState("hslc");
  const [previewImage, setPreviewImage] = useState(null);

  const documentCategories = {
    hslc: {
      label: "HSLC Documents",
      documents: JSON.parse(student.hslc_documents || "[]"),
      images: [
        student.hslc_admit_card_image !== null
          ? "registration_files/" +
            student.contact_number +
            "/hslc/" +
            student.hslc_admit_card_image
          : null,
        student.hslc_marksheet_image !== null
          ? "registration_files/" +
            student.contact_number +
            "/hslc/" +
            student.hslc_marksheet_image
          : null,
        student.hslc_pass_certificate_image !== null
          ? "registration_files/" +
            student.contact_number +
            "/hslc/" +
            student.hslc_pass_certificate_image
          : null,
      ],
    },
    hs: {
      label: "HS Documents",
      documents: JSON.parse(student.hs_documents || "[]"),
      images: [
        student.hs_admit_card_image !== null
          ? "registration_files/" +
            student.contact_number +
            "/hs/" +
            student.hs_admit_card_image
          : null,
        student.hs_marksheet_image !== null
          ? "registration_files/" +
            student.contact_number +
            "/hs/" +
            student.hs_marksheet_image
          : null,
        student.hs_certificate_image !== null
          ? "registration_files/" +
            student.contact_number +
            "/hs/" +
            student.hs_certificate_image
          : null,
        student.hs_migration_image !== null
          ? "registration_files/" +
            student.contact_number +
            "/hs/" +
            student.hs_migration_image
          : null,
        student.cee_admin_card !== null
          ? "registration_files/" +
            student.contact_number +
            "/hs/" +
            student.cee_admin_card
          : null,
        student.cee_marksheet !== null
          ? "registration_files/" +
            student.contact_number +
            "/hs/" +
            student.cee_marksheet
          : null,
      ],
    },
    gnm: {
      label: "GNM Documents",
      documents: JSON.parse(student.gnm_documents || "[]"),
      images: [
        student.gnm_marksheet_image !== null
          ? "registration_files/" +
            student.contact_number +
            "/gnm/" +
            student.gnm_marksheet_image
          : null,
        student.gnm_certificate_image !== null
          ? "registration_files/" +
            student.contact_number +
            "/gnm/" +
            student.gnm_certificate_image
          : null,
        student.gnm_migration_image !== null
          ? "registration_files/" +
            student.contact_number +
            "/gnm/" +
            student.gnm_migration_image
          : null,
      ],
    },
    other: {
      label: "Other Documents",
      documents: JSON.parse(student.other_documents || "[]"),
      images: [
        student.other_prc_image !== null
          ? "registration_files/" +
            student.contact_number +
            "/desclaration/" +
            student.other_prc_image
          : null,
        student.other_caste_image !== null
          ? "registration_files/" +
            student.contact_number +
            "/desclaration/" +
            student.other_caste_image
          : null,
        student.other_registration_image !== null
          ? "registration_files/" +
            student.contact_number +
            "/desclaration/" +
            student.other_registration_image
          : null,
        student.other_experience_image !== null
          ? "registration_files/" +
            student.contact_number +
            "/desclaration/" +
            student.other_experience_image
          : null,
        student.other_certificate_image !== null
          ? "registration_files/" +
            student.contact_number +
            "/desclaration/" +
            student.other_certificate_image
          : null,
      ],
    },
    idProofs: {
      label: "ID Proofs",
      documents: JSON.parse(student.id_proof_documents || "[]"),
      images: [
        student.id_proof_adhaar_image !== null
          ? "registration_files/" +
            student.contact_number +
            "/id_proof/" +
            student.id_proof_adhaar_image
          : null,
        student.id_proof_pan_image !== null
          ? "registration_files/" +
            student.contact_number +
            "/id_proof/" +
            student.id_proof_pan_image
          : null,
        student.id_proof_voter_image !== null
          ? "registration_files/" +
            student.contact_number +
            "/id_proof/" +
            student.id_proof_voter_image
          : null,
      ],
    },
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handlePreview = (image) => {
    setPreviewImage(image);
  };

  const handleClosePreview = () => {
    setPreviewImage(null);
  };

  console.log(student.hs_documents, "check hs files");

    return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h3">Details of {student.name} </Typography>
            <Grid container spacing={3}>
                {/* Personal Information */}
                <Grid item xs={12} md={6}>
          <Card elevation={3} sx={{ height: "100%" }}>
                        <CardContent>
                            <Typography variant="h6" color="primary" gutterBottom>
                                Personal Information
                            </Typography>
                            <Divider sx={{ mb: 2 }} />
              <Grid container spacing={2}>
                {[
                  { label: "Name", value: student.name },
                  { label: "Date of Birth", value: student.dob },
                  { label: "Age", value: student.age },
                  { label: "Gender", value: student.gender },
                  { label: "Nationality", value: student.nationality },
                  { label: "Religion", value: student.religion },
                  { label: "Community", value: student.community },
                  { label: "Category", value: student.category },
                  { label: "Father Name", value: student.father_name },
                  { label: "Mother Name", value: student.mother_name },
                  {
                    label: "Where did he heard of PEWS",
                    value: student.heard_about_us,
                  },
                ].map((item) => (
                  <Grid item xs={12} sm={6} key={item.label}>
                    <Typography variant="subtitle2" color="textSecondary">
                      {item.label}
                    </Typography>
                    <Typography variant="body1">{item.value}</Typography>
                  </Grid>
                ))}
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        {/* Contact Information */}
        <Grid item xs={12} md={6}>
          <Card elevation={3} sx={{ height: "100%" }}>
            <CardContent>
              <Typography variant="h6" color="primary" gutterBottom>
                Contact Information
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <Grid container spacing={2}>
                {[
                  { label: "Contact Number", value: student.contact_number },
                  { label: "WhatsApp Number", value: student.whatsapp_number },
                  { label: "Parents Number", value: student.parents_number },
                  { label: "Email", value: student.email },
                ].map((item) => (
                  <Grid item xs={12} sm={6} key={item.label}>
                                    <Typography variant="subtitle2" color="textSecondary">
                      {item.label}
                                    </Typography>
                    <Typography variant="body1">{item.value}</Typography>
                  </Grid>
                            ))}
              </Grid>
                        </CardContent>
                    </Card>
                </Grid>

                {/* Academic Information */}
        <Grid item xs={12}>
                    <Card elevation={3}>
                        <CardContent>
                            <Typography variant="h6" color="primary" gutterBottom>
                                Academic Information
                            </Typography>
                            <Divider sx={{ mb: 2 }} />
              <Grid container spacing={3}>
                {academicReports.reports.map((report, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <Card variant="outlined">
                      <CardContent>
                        <Typography variant="subtitle1" gutterBottom>
                          {report.nameOfExam}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          Board/University: {report.boardOrUniversity}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          Institute: {report.instituteSchool}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          Year: {report.yearOfPassing}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          Marks: {report.marksObtained} (
                          {report.percentageMarks})
                                    </Typography>
                        </CardContent>
                    </Card>
                </Grid>
                ))}
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12}>
          <Card elevation={3}>
            <CardContent>
              <Typography variant="h6" color="primary" gutterBottom>
                Permanent Address Information
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <Grid container spacing={2}>
                {[
                  { label: "Post Office", value: student.post_office },
                  { label: "Police Station", value: student.police_station },
                  { label: "house Number", value: student.house_number },
                  { label: "Bylane", value: student.bylane },
                  { label: "Town Village", value: student.town_village },
                  { label: "Pin Code", value: student.pin_code },
                  { label: "District", value: student.district },
                  { label: "State", value: student.state },
                ].map((item) => (
                  <Grid item xs={12} sm={6} key={item.label}>
                    <Typography variant="subtitle2" color="textSecondary">
                      {item.label}
                    </Typography>
                    <Typography variant="body1">{item.value}</Typography>
                  </Grid>
                ))}
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12}>
          <Card elevation={3}>
            <CardContent>
              <Typography variant="h6" color="primary" gutterBottom>
                Address for communication
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <Grid container spacing={2}>
                {[
                  { label: "Village/town", value: student.comm_village_town },
                  { label: "Bylane", value: student.comm_path_bylane },
                  { label: "House Number", value: student.comm_house_number },
                  { label: "Post Office", value: student.comm_post_office },
                  {
                    label: "Police Station",
                    value: student.comm_police_station,
                  },
                  { label: "District", value: student.comm_district },
                  { label: "State", value: student.comm_state },
                  { label: "Pincode", value: student.comm_pin_code },
                  { label: "Phone Number", value: student.comm_phone_no_1 },
                  {
                    label: "Alternate Phone Number",
                    value: student.comm_phone_no_2,
                  },
                ].map((item) => (
                  <Grid item xs={12} sm={6} key={item.label}>
                    <Typography variant="subtitle2" color="textSecondary">
                      {item.label}
                    </Typography>
                    <Typography variant="body1">{item.value}</Typography>
                  </Grid>
                ))}
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12}>
                    <Card elevation={3}>
                        <CardContent>
                            <Typography variant="h6" color="primary" gutterBottom>
                Declaration Info
                            </Typography>
                            <Divider sx={{ mb: 2 }} />
              <Grid container spacing={2}>
                {[
                  { label: "Date", value: student.declaration_date },
                  { label: "Place", value: student.declaration_place },
                  {
                    label: "Course Name",
                    value: student.declaration_course_name,
                  },
                  {
                    label: "Relation",
                    value: student.declaration_relationship,
                  },
                  {
                    label: "Occupation",
                    value: student.declaration_occupation,
                  },
                  {
                    label: "For Course",
                    value: student.applied_course,
                  },
                  {
                    label: "Parents Signature",
                    value: student.declaration_parents_signature,
                    type: "file",
                  },
                  {
                    label: "Candidate Signature",
                    value: student.declaration_candidate_signature,
                    type: "file",
                  },
                ].map((item) => (
                  <Grid item xs={12} sm={6} key={item.label}>
                                    <Typography variant="subtitle2" color="textSecondary">
                      {item.label}
                                    </Typography>
                    {item.type === "file" ? (
                      <img
                        src={`${process.env.REACT_APP_BACKEND}registration_files/${student.contact_number}/declaration/${item.value}`}
                        className="img-fluid h-20"
                        style={{ height: 100 }}
                      />
                    ) : (
                      <Typography variant="body1">{item.value}</Typography>
                    )}
                  </Grid>
                ))}
              </Grid>
                        </CardContent>
                    </Card>
                </Grid>

        {/* Documents Section */}
        <Grid item xs={12}>
                    <Card elevation={3}>
                        <CardContent>
                            <Typography variant="h6" color="primary" gutterBottom>
                Documents
                            </Typography>
                            <Divider sx={{ mb: 2 }} />

              <TabContext value={tabValue}>
                <Tabs
                  value={tabValue}
                  onChange={handleTabChange}
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  {Object.entries(documentCategories).map(([key, category]) => (
                    <Tab key={key} label={category.label} value={key} />
                  ))}
                </Tabs>

                <Box sx={{ mt: 2 }}>
                  {Object.entries(documentCategories).map(([key, category]) => (
                    <TabPanel key={key} value={key}>
                      <Grid container spacing={2}>
                        {category.documents.map((doc, index) => (
                          <Grid item xs={12} sm={6} md={4} key={doc}>
                            <Card variant="outlined" sx={{ height: "100%" }}>
                              <CardContent>
                                <Typography variant="subtitle1" gutterBottom>
                                  {doc.replace(/_/g, " ").toUpperCase()}
                                    </Typography>
                                {category.images[index] === null &&
                                  `no ${doc
                                    .replace(/_/g, " ")
                                    .toUpperCase()} Uplaoded`}
                                {category.images[index] && (
                                  <Box
                                    sx={{
                                      position: "relative",
                                      paddingTop: "56.25%", // 16:9 aspect ratio
                                      cursor: "pointer",
                                      "&:hover img": {
                                        transform: "scale(1.05)",
                                      },
                                    }}
                                    onClick={() =>
                                      handlePreview(category.images[index])
                                    }
                                  >
                                    {category.images[index] !== null ? (
                                      <img
                                        src={`${process.env.REACT_APP_BACKEND}${category.images[index]}`}
                                        height={50}
                                        alt={doc}
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "cover",
                                          borderRadius: 4,
                                          transition: "transform 0.3s ease",
                                        }}
                                      />
                                    ) : (
                                      "No Images Uploaded"
                                    )}
                                </Box>
                                )}
                                {console.log(category, "category")}
                              </CardContent>
                            </Card>
                          </Grid>
                        ))}
                      </Grid>
                    </TabPanel>
                  ))}
                </Box>
                <Box>
                  <Typography  variant="h6" color="primary" gutterBottom>Cee Details</Typography>
                  <Box className="flex flex-row" sx={{display : 'flex'}}>
                    <Box
                      onClick={() =>
                        handlePreview(
                          `registration_files/${student.contact_number}/hs/${student.cee_admin_card}`
                        )
                      }
                      className="w-1/3"
                      sx={{flexDirection : 'column'}}
                    >
                      <Typography>
                      Cee Admit Card
                      </Typography>
                      {student.cee_admin_card !== null ? (
                        <img
                          src={`${process.env.REACT_APP_BACKEND}registration_files/${student.contact_number}/hs/${student.cee_admin_card}`}
                          style={{
                            width: "250px",
                            height: "250px",
                            objectFit: "cover",
                            borderRadius: 4,
                            transition: "transform 0.3s ease",
                          }}
                        />
                      ) : (
                        "No Images Uploaded"
                      )}
                    </Box>
                    <Box
                      className="w-1/3"
                      onClick={() =>
                        handlePreview(
                          `registration_files/${student.contact_number}/hs/${student.cee_marksheet}`
                        )
                      }
                      sx={{flexDirection : 'column'}}
                    >
                      <Typography>
                      Cee Marksheet
                      </Typography>
                      {student.cee_marksheet !== null ? (
                        <img
                          src={`${process.env.REACT_APP_BACKEND}registration_files/${student.contact_number}/hs/${student.cee_marksheet}`}
                          style={{
                            width: "250px",
                            height: "250px",
                            objectFit: "cover",
                            borderRadius: 4,
                            transition: "transform 0.3s ease",
                          }}
                        />
                      ) : (
                        "No Images Uploaded"
                      )}
                    </Box>
                  </Box>
                </Box>
              </TabContext>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

      <ImagePreviewModal
        open={Boolean(previewImage)}
        imageUrl={previewImage ? `${previewImage}` : ""}
        onClose={handleClosePreview}
      />
    </Container>
    );
};

export default AdmissionDetails;
